import {
  PFLICHT_KRITERIEN,
  OPTIONALE_KRITERIEN,
  ALLE_KRITERIEN,
  type Kriterium,
} from '../../amplify/shared/guennies';

export const KRITERIUM_LABEL: Record<Kriterium, string> = {
  noteSpaghettiOptik: 'Spaghetti-Optik',
  noteKonsistenz: 'Eis-Konsistenz / Cremigkeit',
  noteGeschmack: 'Eis-Geschmack',
  noteFruchtsauce: 'Erdbeer-/Fruchtsauce',
  noteWeisseRaspel: 'Weiße Raspel („Parmesan")',
  noteSahne: 'Sahne',
  notePortionsgroesse: 'Portionsgröße / Menge',
  notePraesentation: 'Präsentation / Anrichten',
  notePreisLeistung: 'Preis-Leistung',
};

export const KRITERIUM_HILFE: Partial<Record<Kriterium, string>> = {
  noteSpaghettiOptik: 'Pressbild, Nudelform, Länge, Gleichmäßigkeit – das Kernkriterium.',
  noteKonsistenz: 'Cremig vs. kristallig, Temperatur beim Essen.',
  noteFruchtsauce: 'Fruchtanteil, frisch vs. Sirup, Süße, Menge.',
};

/** Feldname der von der Aggregation gepflegten Durchschnittsnote je Kriterium auf `Eisdiele`. */
export const AVG_FELD: Record<Kriterium, string> = {
  noteSpaghettiOptik: 'avgSpaghettiOptik',
  noteKonsistenz: 'avgKonsistenz',
  noteGeschmack: 'avgGeschmack',
  noteFruchtsauce: 'avgFruchtsauce',
  noteWeisseRaspel: 'avgWeisseRaspel',
  noteSahne: 'avgSahne',
  notePortionsgroesse: 'avgPortionsgroesse',
  notePraesentation: 'avgPraesentation',
  notePreisLeistung: 'avgPreisLeistung',
};

export { PFLICHT_KRITERIEN, OPTIONALE_KRITERIEN, ALLE_KRITERIEN };
export type { Kriterium };
